import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { authStore } from '~/stores'

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      authStore.authorization ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/signin', state: { from: props.location } }} />
      )
    }
  />
) 